export const TOTALES = "Totales";